import { createSelector } from 'reselect';
import { CustomReportTypes } from '../../../shared/customReports/constants';

const BATCH_PROVISION_JOURNALS_CUSTOM_REPORT = 'Batch Provision Journals';

const customReportsSelector = ({ reports }) => reports.customReports.customReports;

const customReportToViewIdSelector = ({ reports }) => reports.customReports.customReportToViewId;

export const customReportsDropdownSelector = createSelector(
  customReportsSelector,
  customReports => customReports
    .map(({ reportSetId, reportSetName }) => ({
      value: reportSetId,
      label: reportSetName,
    }))
);

export const batchProvisionJournalsReportAndReportSetIdsSelector = createSelector(
  customReportsSelector,
  customReports => {
    const foundReport = customReports
      .find(({ reportSetName }) => reportSetName === BATCH_PROVISION_JOURNALS_CUSTOM_REPORT);

    return {
      reportId: foundReport?.reports?.[0],
      reportSetId: foundReport?.reportSetId,
    };
  }
);

export const customReportSelector = createSelector(
  customReportsSelector,
  customReportToViewIdSelector,
  (customReports, customReportToViewId) =>
    customReports.find(customReport => customReport.reportSetId === customReportToViewId)
);

export const customReportParamsSelector = ({ reports }) =>
  reports.customReports.customReportParams;

export const isCustomReportRunInProgressSelector = ({ reports }) =>
  reports.customReports.isCustomReportRunInProgress;

export const customReportResponseDataSelector = ({ reports }) =>
  reports.customReports.customReportData;

export const isReportSetOpenSelector = state => {
  const customReport = customReportSelector(state);
  if (customReport) {
    return customReport.customReportType === CustomReportTypes.REPORT_SET;
  }
  return false;
};

export const customReportSetReportsSelector = ({ reports }) => reports.customReports.customReportSetReports;

export const isBusySelector = ({ reports }) =>
  reports.customReports.isFetchingCustomReports
    || reports.customReports.isCustomReportRunInProgress
    || reports.customReports.isFetchingCustomReportSet
    || reports.customReports.isExportInProgress;

export const customReportQueryParamsSelector = ({ reports }) => reports.customReports.queryParams;

export const isFetchingCustomReportParamsSelector = ({ reports }) => reports.customReports.isFetchingCustomReportParams;
